var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition-group',{class:_vm.baseClass,attrs:{"tag":"div","name":`${_vm.baseClass}__breadcrumb--animated`}},_vm._l((_vm.breadcrumbs),function(breadcrumb){return _c('router-link',{key:breadcrumb.id,class:[
      `${_vm.baseClass}__breadcrumb`,
      {
        [`${_vm.baseClass}__breadcrumb--accessible`]:
          !!breadcrumb.routeName && _vm.isBreadcrumbClickable(breadcrumb),
      },
      {
        [`${_vm.baseClass}__breadcrumb--highlights`]:
          _vm.isHighlightsBreadcrumb(breadcrumb.id) && !_vm.isCurrentRoute(breadcrumb.routeName),
      },
      { [`${_vm.baseClass}__breadcrumb--non-clickable`]: !_vm.isBreadcrumbClickable(breadcrumb) },
    ],attrs:{"tag":"button","to":_vm.isBreadcrumbClickable(breadcrumb) ? { ..._vm.$route, name: breadcrumb.routeName } : ''}},[(_vm.isHighlightsBreadcrumb(breadcrumb.id))?_c('span',{class:`${_vm.baseClass}__icon ${_vm.baseClass}__icon--highlights eicon`},[_vm._v("\n      highlights\n    ")]):_vm._e(),_c('span',{class:`${_vm.baseClass}__text ${_vm.baseClass}__text--label`},[_vm._v("\n      "+_vm._s(breadcrumb.label)+"\n    ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }